<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Contact Us" pageTitle="Contact Us" />
            <ContactUs />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import ContactUs from '../ContactUs/ContactUs'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'ContactUsPage',
    components: {
        MainHeader,
        PageTitle,
        ContactUs,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>